const CopyToClipboard = (text) => {
    // console.log(event.currentTarget)
    navigator.clipboard.writeText(text);
    // event.currentTarget.classList.add("copied");
    // setTimeout(() => {
    //   event.currentTarget.classList.remove("copied");
    // }, 1000);
  };

export default CopyToClipboard